// removed by extract-text-webpack-plugin
module.exports = {"wrapHeader":"src-components-modules-LandingPagesWrap-style----landing-pages-wrap-module---wrapHeader---3GPRu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/LandingPagesWrap/style/landing-pages-wrap.module.css
// module id = 1485
// module chunks = 168707334958949